<!--
  二维码生成器
  直接调用当前页可传参数
-->
<template>
  <div class="QRCode">
    <div id="qrcode"></div>
  </div>
</template>
<script>
import QRCode  from "qrcodejs2"
import * as config from '../../../../static/js/config'
var vm
export default {
  data(){
    return {
      link: 'http://baidu.com',
    }
  },
  components:{ 
    QRCode,
  },
  created(){
    vm = this
    let url = location.hash
    console.log(location.hash)
    if(location.hash.indexOf("?")){
      url = url.substr(location.hash.indexOf("?"))
      url = this.link+url
    }else{
      url = this.link
    }
    
    this.$nextTick (function () {
      vm.qrcode(url)
    })
  },
  methods:{
    //  生成二维码
    qrcode (url) {
      let that = this;
      let qrcode = new QRCode('qrcode', {
        width: 200,
        height: 200,        // 高度
        text:  url,   // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#fff',   // 背景色
        // foreground: '#000'    // 前景色
      })

      //把图片以流的形式下载：放到id为aaa的a标签里面
      // var img = document.getElementById('qrcode').getElementsByTagName('img')[0];
      // // 构建画布
      // var canvas = document.createElement('canvas');
      // canvas.width = img.width;
      // canvas.height = img.height;
      // canvas.getContext('2d').drawImage(img, 0, 0);
      // // 构造url
      // var url = canvas.toDataURL('image/png');
      // document.getElementById('aaa').setAttribute('href', url);
    }
  },
  watch:{

  }
}
</script>

<style lang="scss">
  .QRCode{
    text-align: center;
    padding-top: 1rem;
    box-sizing: border-box;
    img{
      width: 2rem;
      height: 2rem;
      margin: 0 auto;
      padding: 0.1rem;
      background: #fff;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/PhonePage/Fresh/QRCode.vue